import { useState } from "react";
import { MapPin, Phone, Mail, Clock, Send } from "lucide-react";
import { siteData } from "../../data/siteData";
import "./Contact.css";

export default function Contact() {
  const [form, setForm] = useState({ name:"", phone:"", service:"", message:"" });
  const [sent, setSent] = useState(false);
  const onChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const onSubmit = e => { e.preventDefault(); setSent(true); setTimeout(()=>setSent(false),3500); };

  return (
    <section className="contact" id="kontak">
      <div className="contact__bg">
        <img src="https://images.unsplash.com/photo-1623358519330-00f61d89396b?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="bg" />
      </div>

      <div className="container contact__inner">
        {/* LEFT */}
        <div>
          <span className="eyebrow" style={{ color:"rgba(255,255,255,.5)" }}>Hubungi Kami</span>
          <h2 className="contact__title">Siap Mewujudkan <em>Taman Impian</em> Anda?</h2>
          <p className="contact__desc">Konsultasikan kebutuhan penghijauan Anda bersama kami — gratis dan tanpa syarat!</p>

          <div className="contact__details">
            {[
              { icon:<MapPin size={17}/>, label:"Alamat", val: siteData.company.address },
              { icon:<Phone size={17}/>, label:"Telepon / WhatsApp", val: siteData.company.phone, href:`tel:${siteData.company.phone}` },
              { icon:<Mail size={17}/>,  label:"Email", val: siteData.company.email, href:`mailto:${siteData.company.email}` },
              { icon:<Clock size={17}/>, label:"Jam Operasional", val:"Senin – Sabtu: 08.00 – 17.00 WIB" },
            ].map(d => (
              <div className="contact__detail" key={d.label}>
                <div className="contact__det-icon">{d.icon}</div>
                <div>
                  <div className="contact__det-label">{d.label}</div>
                  <div className="contact__det-val">
                    {d.href ? <a href={d.href}>{d.val}</a> : d.val}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <a href={siteData.company.whatsapp} className="contact__wa" target="_blank" rel="noreferrer">
            💬 Chat via WhatsApp
          </a>
        </div>

        {/* RIGHT */}
        {/* <div className="contact__form-card">
          <h3 className="contact__form-title">Kirim Pesan</h3>
          {sent ? (
            <div className="contact__success">✅ Pesan terkirim! Kami akan segera menghubungi Anda.</div>
          ) : (
            <form className="contact__form" onSubmit={onSubmit}>
              {[
                { label:"Nama Lengkap", name:"name", type:"text", placeholder:"Nama Anda" },
                { label:"Nomor Telepon", name:"phone", type:"tel", placeholder:"08xx-xxxx-xxxx" },
              ].map(f => (
                <div className="cf-field" key={f.name}>
                  <label>{f.label}</label>
                  <input {...f} value={form[f.name]} onChange={onChange} required />
                </div>
              ))}
              <div className="cf-field">
                <label>Layanan</label>
                <select name="service" value={form.service} onChange={onChange} required>
                  <option value="">Pilih layanan...</option>
                  <option>Jasa Landscape Taman</option>
                  <option>Jasa Penghijauan & Reboisasi</option>
                  <option>Suplai Bibit & Pohon</option>
                  <option>Konsultasi Umum</option>
                </select>
              </div>
              <div className="cf-field">
                <label>Pesan</label>
                <textarea name="message" rows={4} value={form.message} onChange={onChange} placeholder="Ceritakan kebutuhan Anda..." required />
              </div>
              <button type="submit" className="btn btn-green contact__submit">
                <Send size={15} /> Kirim Pesan
              </button>
            </form>
          )}
        </div> */}
      </div>
    </section>
  );
}
